import React from "react";
import Form from "react-bootstrap/Form";
import { useField } from "formik";

import "./SliderTextInput.css";

const fieldNameToTour = (fieldName) => {
  switch (fieldName) {
    case "PM_min":
      return "5";

    default:
      return "0";
  }
};

const SliderTextInput = (props) => {
  const [field, meta] = useField(props);

  return (
    <Form.Group
      controlId={props.name}
      className="f-group"
      data-tour={fieldNameToTour(props.name)}
    >
      <Form.Label>{props.title}</Form.Label>

      <Form.Control
        id={props.name + "-text"}
        className="form-input"
        type={props.type}
        name={props.name}
        min={props.min}
        max={props.max}
        step={props.step}
        placeholder={props.placeholder}
        value={field.value}
        onChange={field.onChange}
        aria-labelledby={props.name + "-desc"}
      />
      <Form.Control
        id={props.name + "-slider"}
        type="range"
        className="custom-slider"
        name={props.name}
        placeholder={props.placeholder}
        min={props.min}
        max={props.max}
        step={props.step}
        value={field.value}
        onChange={field.onChange}
        aria-labelledby={props.name + "-desc"}
      />
      {meta.error ? <div className="error">{meta.error}</div> : null}
      <Form.Text id={props.name + "-desc"}>{props.desc}</Form.Text>
    </Form.Group>
  );
};

export default SliderTextInput;
